var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReductioninservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_38839",
    x: 4.127,
    y: 10.4,
    width: 43.744,
    height: 27.677,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38840",
    x: 17.694,
    y: 18.223,
    width: 16.613,
    height: 17.141,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reduction_in_service",
    "data-name": "Reduction in service",
    transform: "translate(-1043.518 -1239.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38838",
    "data-name": "Path 38838",
    d: "M26,0A26,26,0,1,1,0,26,26,26,0,0,1,26,0",
    transform: "translate(1043.518 1239.438)",
    fill: "#d31d25"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1043.52, 1239.44)",
    filter: "url(#Path_38839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38839-2",
    "data-name": "Path 38839",
    d: "M44.207,24.029a7.308,7.308,0,0,0-7.257-7.358,7.511,7.511,0,0,0-1.251.1,4.917,4.917,0,0,0-7.675-3.845,7.511,7.511,0,0,0-14.852.366c-.214-.016-.429-.026-.647-.026a9.06,9.06,0,1,0,0,18.12l.107,0v0H36.905v0a7.355,7.355,0,0,0,7.3-7.355",
    transform: "translate(2.16 4.19)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1043.52, 1239.44)",
    filter: "url(#Path_38840)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38840-2",
    "data-name": "Path 38840",
    d: "M19.087,11.522a6.943,6.943,0,0,0-6.807,7.07,6.943,6.943,0,0,0,6.807,7.07,6.942,6.942,0,0,0,6.806-7.07,6.942,6.942,0,0,0-6.806-7.07m5.106,7.07a5.423,5.423,0,0,1-.887,2.983L16.19,14.231a4.945,4.945,0,0,1,2.9-.943,5.205,5.205,0,0,1,5.1,5.3m-10.21,0a5.429,5.429,0,0,1,.847-2.919L21.924,23a4.946,4.946,0,0,1-2.839.9,5.205,5.205,0,0,1-5.1-5.3",
    transform: "translate(6.91 7.2)",
    fill: "#d31d25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReductioninservice);
export default __webpack_public_path__ + "static/media/Reduction in service.45a649fc58d6d7a58a6a980136d51c48.svg";
export { ForwardRef as ReactComponent };